var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"align-center section"},[_c('h4',{staticClass:"text-h4"},[_vm._v(" You need to "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.signIn}},[_vm._v("sign in")]),_vm._v(" to continue. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }